import axios from "axios";

export default function validateInfo(values) {
  let errors = {};
  console.log("values", values);

  if ("username" in values && !values.username.trim()) {
    errors.username = "Required";
  }

  if ("name" in values && !values.name.trim()) {
    errors.name = "Required";
  }

  if ("firstName" in values && !values.firstName.trim()) {
    errors.firstName = "Required";
  }

  if ("lastName" in values && !values.lastName.trim()) {
    errors.lastName = "Required";
  }

  if ("message" in values && !values.message.trim()) {
    errors.message = "Required";
  }

  //Email
  if ("email" in values && !values.email) {
    errors.email = "Email required";
  } else if ("email" in values && !/\S+@\S+\.\S+/.test(values.email)) {
    errors.email = "Email address is invalid";
  }

  //old password
  if ("oldPassword" in values && !values.oldPassword) {
    errors.oldPassword = "Current Password Required";
  }

  //password
  if ("password" in values && !values.password) {
    errors.password = "Password required";
  } else if ("password" in values && values.password.length < 6) {
    errors.password = "Password needs to be 6 characters or more";
  }

  // Confirm Password
  if ("confirmPassword" in values && !values.confirmPassword) {
    errors.confirmPassword = "Password required";
  } else if (
    "confirmPassword" in values &&
    values.password !== values.confirmPassword
  ) {
    errors.confirmPassword = "Password didn't match";
  }

  // Date
  if ("dateOfBirth" in values && !values.dateOfBirth) {
    errors.dob = "Required";
  } else if (
    "dateOfBirth" in values &&
    !/^(?:[012]\d{3})-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12]\d|3[01])$/.test(
      values.dateOfBirth
    )
  ) {
    errors.dob = "Not a valid date. Check DD/MM/YYYY format and range.";
  }

  if ("gender" in values && !values.gender.trim()) {
    errors.gender = "Required";
  }

  //Phone Number
  if ("phoneNumber" in values && !values.phoneNumber) {
    errors.phoneNumber = "Required";
  } else if (
    "phoneNumber" in values &&
    !/^(\+91|0)?[6789]\d{9}$/.test(values.phoneNumber)
  ) {
    errors.phoneNumber = "Not a valid Indian phone number";
  }

  // Check if the state is valid state or not
  if ("shippingAddress" in values) {
    if (
      "address" in values.shippingAddress &&
      !values.shippingAddress.address.trim()
    ) {
      errors.address = "Required";
    }

    if (
      "state" in values.shippingAddress &&
      !values.shippingAddress.state.trim()
    ) {
      errors.state = "Required";
    }

    if (
      "city" in values.shippingAddress &&
      !values.shippingAddress.city.trim()
    ) {
      errors.city = "Required";
    }

    if (
      "pincode" in values.shippingAddress &&
      !values.shippingAddress.pincode
    ) {
      errors.pincode = "Required";
    } else if ("pincode" in values.shippingAddress) {
      const pin = values.shippingAddress.pincode;
      // console.log(values.shippingAddress.pincode);
      async function getpincode() {
        await axios
          .get(`https://api.postalpincode.in/pincode/${pin}`)
          .then((res) => {
            // console.log(res.data[0].Message);
            if (res.data[0].Message === "No records found") {
              errors.pincode = "Invalid Pincode";
            }
          });
      }
      getpincode();
    }
  }

  return errors;
}
